import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#878787",
      "fill-rule": "evenodd",
      d: "M11.505 3.95a1 1 0 0 1 .992 0zm0 0-6.22 3.591 6.717 3.879 6.716-3.878-6.22-3.591m8.573 3.336a1 1 0 0 0-.054-.094 2.8 2.8 0 0 0-.996-.977l-6.624-3.824a2.8 2.8 0 0 0-2.792 0L3.98 6.216a2.79 2.79 0 0 0-1.397 2.418v7.649c0 .998.532 1.92 1.396 2.419l6.625 3.824a2.8 2.8 0 0 0 2.792 0l6.624-3.824a2.79 2.79 0 0 0 1.397-2.419V8.635c0-.479-.123-.941-.347-1.347m-1.453 1.815L12.9 12.979v7.755l6.22-3.59a.99.99 0 0 0 .497-.86zM11.1 20.734v-7.756L4.384 9.1v7.183c0 .354.189.682.496.86z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }